export default "__VITE_ASSET__KZz2Xbqz__"